import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  alignment?: 'left' | 'center';
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  alignment = 'center',
  light = false
}: SectionHeadingProps) {
  return <div className={`mb-12 ${alignment === 'center' ? 'text-center' : 'text-left'}`} data-id="element-86">
      {subtitle && <span className={`block text-sm font-bold tracking-wider uppercase mb-2 ${light ? 'text-green-400' : 'text-green-600'}`} data-id="element-87">
          {subtitle}
        </span>}
      <h2 className={`text-3xl md:text-4xl font-bold ${light ? 'text-white' : 'text-slate-900'}`} data-id="element-88">
        {title}
      </h2>
      <div className={`mt-4 h-1.5 w-20 bg-green-500 rounded-full ${alignment === 'center' ? 'mx-auto' : ''}`} data-id="element-89" />
    </div>;
}